import Layout from '@layout/Index'

export const clbAlipayFlow = [
  {
    path: '/clb-alipay-flow',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "clb-alipay-flow-table" */ './pages/ClbAlipayFlowTable.vue'),
        meta: {
          title: '查理宝支付宝流水列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "clb-alipay-flow-form" */ './pages/ClbAlipayFlowForm.vue'),
        meta: {
          title: '添加查理宝支付宝流水',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "clb-alipay-flow-form" */ './pages/ClbAlipayFlowForm.vue'),
        meta: {
          title: '修改查理宝支付宝流水',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "clb-alipay-flow-detail" */ './pages/ClbAlipayFlowDetail.vue'),
        meta: {
          title: '查理宝支付宝流水详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-alipay-flow/clb-alipay-flow.route.js